import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { selectConfig } from '../../Api/selectors';
import Modal from '../../../containers/App/Components/Modal/Modal';
import { Button } from '../../../components/Buttons';
import { VBox } from '../../../components/Box';
import { BaseComponent } from '../../../components/BaseComponent';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';

class CarcollectCredentialModalComp extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedCredentialId: null,
    };
  }

  componentDidMount() {
    const { serverConfig } = this.props;
    // Auto-select the first credential if available
    if (serverConfig?.carcollectCredentials?.length > 0) {
      this.setState({ selectedCredentialId: serverConfig.carcollectCredentials[0].id });
    }
  }

  handleCredentialSelect = credentialId => {
    this.setState({ selectedCredentialId: credentialId });
  };

  handleConfirm = () => {
    if (this.props.onConfirm) {
      this.props.onConfirm(this.state.selectedCredentialId);
    }
  };

  handleCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  };

  render() {
    const { serverConfig } = this.props;
    const { selectedCredentialId } = this.state;

    if (!serverConfig?.carcollectCredentials?.length) {
      // If no credentials, proceed with default behavior
      this.handleConfirm();
      return null;
    }

    return (
      <Modal title={this.lbl('carcollect.select_credential')} onClose={this.handleCancel} size="md">
        <VBox gap={20}>
          <div>
            <label>{this.lbl('carcollect.select_credential_label')}</label>
            <select
              className="form-control"
              value={selectedCredentialId || ''}
              onChange={e => this.handleCredentialSelect(e.target.value ? parseInt(e.target.value, 10) : null)}
            >
              {serverConfig.carcollectCredentials.map(credential => (
                <option key={credential.id} value={credential.id}>
                  {env.clientId !== AppClientId.HOOIKAMMER
                    ? credential.id == '1'
                      ? 'Externe veiling'
                      : 'Buy now veiling'
                    : credential.id == '1'
                    ? 'Hiltermann veiling'
                    : 'Hooikammer Veiling'}
                </option>
              ))}
            </select>
          </div>

          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <Button variant="secondary" onClick={this.handleCancel}>
              {this.lbl('cancel')}
            </Button>
            <Button variant="primary" onClick={this.handleConfirm} disabled={!selectedCredentialId}>
              {this.lbl('confirm')}
            </Button>
          </div>
        </VBox>
      </Modal>
    );
  }
}

CarcollectCredentialModalComp.propTypes = {
  serverConfig: PropTypes.object,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  serverConfig: selectConfig(),
});

export const CarcollectCredentialModal = compose(connect(mapStateToProps), injectIntl)(CarcollectCredentialModalComp);
